import React from "react";
import { Link } from "react-router-dom";

const PaymentCancelled = () => {
  return (
    <div className="w-full h-dvh">
      <div className="flex items-center justify-center flex-col h-full">
        <h1 className="lg:text-4xl md:text-4xl text-3xl font-bold text-center text-[#74716d]">
          Your Payment Was Cancelled
        </h1>
        <p className="text-center lg:mt-4 md:mt-3 mt-2 text-[#74716d]">
          It seems that your payment was not completed successfully. If you have
          <br />
          any questions or need assistance, please contact our support team.
        </p>
        <Link
          to={"/"}
          className="btn btn-sm bg-[#c3a963] text-white hover:text-[#c3a963] hover:bg-[#ffffff] hover:no-underline font-thin mt-4"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancelled;
